export { default as letterBottom } from "./letter-bottom.svg?react";
export { default as letterTop } from "./letter-top.svg?react";
export { default as letterStamp } from "./letter-stamp.svg?react";
